import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './style.js';
import './assets/iconfont/iconfont';

ReactDOM.render(<App />, document.getElementById('root'));
